// extracted by mini-css-extract-plugin
export default {"wrapper":"fiHNU","mobile":"TPM66","desktop":"rETQD","navbar":"YGMS6","navbarLink":"rukcN","active":"fM5QC","heading":"RAqeh","content":"c8tIc","menu-item-wrapper":"QyVHx"};